import { onAuthStateChanged } from '@firebase/auth'
import { doc, onSnapshot, Unsubscribe } from 'firebase/firestore'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useLoadAds } from '@/contexts/ads'
import { auth, firestore } from '@/services/firebase.service'
import { useActionless } from '@/store/hooks'
import { SET_USER_STATE_FULL, SIGN_OUT } from '@/store/user/actions/types'
import { UserStateType } from '@/store/user/initialState'
import { sha1Encode } from '@/utils/helpers'

const mvIdentityAPI = (emailHash: string) => {
  console.log('identityOptIn', emailHash)
  try {
    // @ts-ignore
    const r = awaitwindow.$adManagementConfig.web.identityOptIn({ email: emailHash })
    console.log('identityOptIn (1)', r)
  } catch {
    window.addEventListener('mediavineIdentityReady', () => {
      // @ts-ignore
      const r = window.$adManagementConfig.web.identityOptIn({ email: emailHash })
      console.log('identityOptIn (2)', r)
    })
  }
}

let unsub: Unsubscribe | undefined

const FirebaseAuth = () => {
  const dispatch = useDispatch()
  const loadAds = useLoadAds()
  const [setUserStateFull] = useActionless(SET_USER_STATE_FULL)
  const [emailHash, setEmailHash] = useState<string | null>(null)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        setEmailHash(await sha1Encode(user.email as string))

        unsub = onSnapshot(doc(firestore, 'users', user.uid), (doc) => {
          const data = doc.data() as UserStateType
          setUserStateFull({ ...data, uid: user.uid }) // Use subobject reference to avoid stale callback
        })
      } else {
        dispatch({ type: SIGN_OUT })

        if (unsub) {
          unsub()
        }
      }
    })
  }, [])

  // Calls MV Identity API once per session, if logged in and ads are enabled
  useEffect(() => {
    console.log({ emailHash, isInitialized, loadAds })
    if (emailHash && loadAds === true && !isInitialized) {
      console.log('triggering identityOptIn')
      setIsInitialized(true)
      mvIdentityAPI(emailHash)
    }
  }, [emailHash, loadAds])

  return null
}

export default FirebaseAuth
